import FeatureGates from '@atlaskit/feature-gate-js-client';

export const useIsBlogTreeUnderContentTreeFFEnabled = () => {
	return FeatureGates.checkGate('blog_tree_under_content_tree');
};
